import React, { useState } from "react";
import { saveDraft, saveLastRigId } from "../persistence/localStorage";

const defaultNavigate = (url) => { window.location.href = url; };

export default function EditAsCopyButton({
  authenticated,
  canCopy,
  sourceRigId,
  apiClient,
  nodes,
  edges,
  rigCables,
  rigName,
  rigDescription,
  rigNotes,
  navigate = defaultNavigate,
}) {
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const handleClick = async (e) => {
    if (!canCopy || busy) {
      e.preventDefault();
      return;
    }

    if (authenticated && apiClient && sourceRigId) {
      e.preventDefault();
      setBusy(true);
      setError(null);
      try {
        const result = await apiClient.duplicateRig(sourceRigId);
        saveLastRigId(result.rig.id);
        navigate("/");
      } catch (err) {
        setBusy(false);
        setError(err?.message || "Could not copy this rig. Please try again.");
      }
      return;
    }

    // Anonymous: save draft and let the link navigate to "/"
    saveDraft({ nodes, edges, rigCables, rigName, rigDescription, rigNotes });
  };

  const href = "/";
  const disabledClass = !canCopy || busy ? " board-editor-copy-btn--disabled" : "";

  return (
    <>
      <a
        href={canCopy && !busy ? href : undefined}
        className={`board-editor-copy-btn${disabledClass}`}
        onClick={handleClick}
        title={canCopy ? "Edit as copy" : "No rig slots available"}
        aria-disabled={!canCopy || busy}
      >
        {busy ? "Copying..." : "Edit as copy"}
      </a>
      {error && (
        <span className="board-editor-copy-error" role="alert">
          {error}
        </span>
      )}
    </>
  );
}
